export const CONTACT_OPTIONS = [
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Llamada', label: 'Llamada' },
];

export const DISCIPLESHIP_OPTIONS = [
  {
    value: 'Sí',
    title: '¡Sí, me encantaría!',
    subtitle: 'Quiero integrarme y ser acompañado.',
    icon: 'users',
  },
  {
    value: 'No',
    title: 'No lo considero por el momento',
    subtitle: 'Prefiero esperar u obtener más orientación primero',
    icon: 'compass outline',
  },
];

export const GROUP_FLOW_STEPS = [
  { id: 'form', label: 'TUS DATOS' },
  { id: 'groupPreference', label: 'TU PREFERENCIA' },
  { id: 'selectGroup', label: 'ELIGE TU GRUPO' },
];

export const getPreferenceOptions = (gender, { includeCouples = false } = {}) => {
  const isFemale = gender === 'Femenino';
  const options = [
    {
      value: 'gender',
      title: isFemale ? 'Solo Mujeres' : 'Solo Hombres',
      subtitle: isFemale
        ? 'Grupos formados exclusivamente por mujeres de tu generación.'
        : 'Grupos formados exclusivamente por varones de tu generación.',
    },
  ];

  if (includeCouples) {
    options.push({
      value: 'couples',
      title: 'Grupo de Parejas',
      subtitle: 'Grupos pensados para parejas casadas o en unión libre.',
    });
  } else {
    options.push({
      value: 'mixed',
      title: 'Grupo Mixto',
      subtitle: 'Grupos integrados por hombres y mujeres de tu generación.',
    });
  }

  return options;
};

export const getPreferenceQuestion = (gender, { includeCouples = false } = {}) => {
  if (includeCouples) {
    return gender === 'Femenino'
      ? '¿Prefieres un grupo de parejas o un grupo solo de mujeres?'
      : '¿Prefieres un grupo de parejas o un grupo solo de hombres?';
  }

  return gender === 'Femenino'
    ? '¿Prefieres un grupo mixto o un grupo solo de mujeres?'
    : '¿Prefieres un grupo mixto o un grupo solo de hombres?';
};
